import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['elementToToggle'];

  visibility() {
    this.elementToToggleTargets.forEach((element) => element.classList.toggle('hidden'));
  }
}
